import React from "react";
export default (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42216 42216",
    className: "icon",
    style: {
      height: "1em",
      width: "1em"
    }
  }, React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2533.11",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26917 26916l9672 9673m-7012 -23366c-2693,-6339 -10016,-9293 -16354,-6599 -6339,2693 -9293,10016 -6599,16354 2693,6339 10016,9293 16354,6599 6339,-2693 9293,-10016 6599,-16354z"
  }));
});